// extracted by mini-css-extract-plugin
export var contentContainer = "index-module--contentContainer--ej7Ku";
export var contentContainerMb = "index-module--contentContainerMb--EZePq";
export var listItem = "index-module--listItem--8nVTE";
export var logoTitle = "index-module--logoTitle--tXPAr";
export var swiper = "index-module--swiper--YcfM+";
export var swiperList = "index-module--swiperList--8sGJA";
export var title = "index-module--title--SYlIS";